import React from 'react';
import ToggleButton from './toggleButton';
import ColorLine from './colorLine';

export default class CardHeader extends React.Component {
  render() {
    return (
      <div className="cardheader">
        <div className="cardheader__primary">
          <h3>{this.props.primaryTitle}</h3>

          {/* <ToggleButton
            onPressButton={this.props.onPressButton}
            showingGMT={this.props.showingGMT}
          /> */}
        </div>

        <div className="cardheader__secondary">
          <h3>{this.props.secondaryTitle}</h3>
          <p>{this.props.secondarySubTitle}</p>
          {<ColorLine onOpenMap={this.props.onOpenMap} description={this.props.description} />}
        </div>

        <div className="cardheader__children" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cardheader.js